






import { Component, Vue } from 'vue-property-decorator';

import PortalCustomersList from '@/componentsV2/templates/PortalCustomersList/PortalCustomersList.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

@Component({
  components: {
    PortalCustomersList,
    Page
  }
})
export default class CustomerList extends Vue {
  mounted() {}
}
